'use strict'

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {find, findIn, findAllIn, closest, trigger, triggerWith} from "../libs/@elements/dom-utils";
import fetch from '../libs/@elements/fetch'; // IE10 Polyfill
import 'url-search-params-polyfill'; // Edge Polyfill
import formDataEntries from 'form-data-entries';
import {submitAjaxForm} from "./friendlyCaptchaV1";
import Pristine from "../libs/pristine/pristine.js";
import throwError from "../libs/@elements/throw-error"

const Selectors = {
    Rating: '.js-rate-product',
    RatingForm: '.js-add-product-rating__form',
    AddRating: 'j.s-add-product-rating',
    RateProductStar: '.js-rate-product__star',
    RateProductStarVisual: '.js-rate-product-star-visual',
    ajaxReviewFormModalEl: '#feedbackModal',
    ajaxReviewFormModalContentWrapperEl: '.ajax-review-form-modal-content-wrapper'
}

const Attributes = {
   AjaxReviewFormModalAction: 'data-ajax-review-form-modal-action'
}

const States = {
   IsLoading: 'is-loading'
}

const AJAX_REVIEW_FORM_MODAL_REQUEST_RENDERED_CONTENT_EVENT = 'ajaxReviewFormModalRequest:renderedContent';
const AJAX_REVIEW_FORM_MODAL_REQUEST_FINISHED_EVENT = 'ajaxReviewFormModalRequest:finished';
const AJAX_REVIEW_FORM_MODAL_REQUEST_ERRORED_EVENT = 'ajaxReviewFormModalRequest:errored';

let ajaxReviewFormModalEl;
let ajaxReviewFormModalContentWrapperEl;
let ajaxReviewFormModalContentWrapperHTML = null;
let ajaxReviewFormModalAction = false;
let ajaxReviewFormModalRequest = false;

export function init() {
    onFind(Selectors.ajaxReviewFormModalEl, (element) => {
        ajaxReviewFormModalEl = element ?? throwError("1658239223 Product rating JS – Modal missing");
        ajaxReviewFormModalContentWrapperEl = findIn(Selectors.ajaxReviewFormModalContentWrapperEl, element) ?? throwError("1658239325 Product rating JS – Modal content wrapper missing");
        ajaxReviewFormModalAction = element.getAttribute(Attributes.AjaxReviewFormModalAction) ?? throwError("1658239355 Product rating JS – Modal ajax form action missing");

        ajaxReviewFormModalEl.addEventListener('show.bs.modal', onModalShow);
        ajaxReviewFormModalEl.addEventListener(AJAX_REVIEW_FORM_MODAL_REQUEST_RENDERED_CONTENT_EVENT, onAjaxReviewFormModalRequestContentRendered);
        ajaxReviewFormModalEl.addEventListener(AJAX_REVIEW_FORM_MODAL_REQUEST_FINISHED_EVENT, onAjaxReviewFormModalRequestFinished);
        ajaxReviewFormModalEl.addEventListener(AJAX_REVIEW_FORM_MODAL_REQUEST_ERRORED_EVENT,onAjaxReviewFormModalRequestErrored);
    });
}

function onModalShow() {
    setAjaxReviewFormModalContent();
}

function setAjaxReviewFormModalContent() {
    // If request is already pending or content is already loaded, do nothing
    if (ajaxReviewFormModalRequest || ajaxReviewFormModalContentWrapperHTML ) return;

    ajaxReviewFormModalRequest = false;
    ajaxReviewFormModalContentWrapperEl.innerHTML = '';

    ajaxReviewFormModalEl.classList.add(States.IsLoading);

    ajaxReviewFormModalRequest = fetch(ajaxReviewFormModalAction, { method: 'GET' });

    ajaxReviewFormModalRequest.then(response => {
        ajaxReviewFormModalContentWrapperHTML = response.clone().json();
        return ajaxReviewFormModalContentWrapperHTML
    }).then(response => {
        if (!response || !response.success) throw new Error('1658239409 Product rating JS - Invalid ajax review form response')
        if (!response.html) throw new Error('1658239423 Product rating JS - Empty ajax review form response')

        ajaxReviewFormModalContentWrapperEl.innerHTML = response.html;
        trigger(AJAX_REVIEW_FORM_MODAL_REQUEST_RENDERED_CONTENT_EVENT, ajaxReviewFormModalEl);
    }).finally(() => {
        trigger(AJAX_REVIEW_FORM_MODAL_REQUEST_FINISHED_EVENT, ajaxReviewFormModalEl);
    }).catch(error => {
        triggerWith(AJAX_REVIEW_FORM_MODAL_REQUEST_ERRORED_EVENT, {error: error}, ajaxReviewFormModalEl);
    })
}

function onAjaxReviewFormModalRequestContentRendered() {
    initProductRating();
}

function onAjaxReviewFormModalRequestFinished() {
    ajaxReviewFormModalEl.classList.remove(States.IsLoading);
    ajaxReviewFormModalRequest = false
}

function onAjaxReviewFormModalRequestErrored(event) {
    if (!event || !event.detail || !event.detail.error) return
    console && console.error && console.error(event.detail.error);
}

export function initProductRating() {

    onFind(Selectors.RatingForm, (element) => {
        window && window.app && window.app.floatingLabel && window.app.floatingLabel();
        window && window.app && window.app.formValidation && window.app.formValidation();
        window && window.app && window.app.friendlyCaptchaV1 && window.app.friendlyCaptchaV1();
        
        let rating = find(Selectors.Rating);
        initRating();


        let addRating = find('.js-add-product-rating');
        let dismissRating = find('.dismiss-product-rating');
        let endRating = find('.end-product-rating');
        let addRatingForm = find('.js-add-product-rating__form');
        let rateProductStars = findAllIn(Selectors.RateProductStar, rating);
        const ratingInputs = findAllIn('input', rating);
        let currentContent;
        let pendingRequest;
        let content = find('.js-content');

        const loading = find('.js-modal__loading');

        // create the pristine instance
        let pristine = new Pristine(addRatingForm);

        addRating.addEventListener('click', (event) => {
            if(pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            event.preventDefault();

            if(!pristine.validate()){
                return;
            }

            showLoading();

            let url = event.currentTarget.getAttribute('data-url');
            let formData = new URLSearchParams(formDataEntries(addRatingForm));

            submitAjaxForm(url, formData, sendRequest);
        });

        function sendRequest(url, formData) {

            pendingRequest = fetch(url, {
                method: 'POST',
                body: formData
            });

            pendingRequest.then((res) => {
                return res.clone().json()
            }).then((res) => {
                if(res.success){
                    if(res.html){
                        const $response = res.html;

                        currentContent = content.innerHTML;

                        content.innerHTML = $response;
                        addRating.classList.add('d-none');
                        dismissRating.classList.add('d-none');
                        endRating.classList.remove('d-none');
                    }
                }
            }).finally(() => {
                hideLoading();
            })
        }

        function showLoading(){
            loading.removeAttribute('hidden');
        }

        function hideLoading(){
            loading.setAttribute('hidden', true);
        }

        function initRating(){

            rating.addEventListener('mouseleave', (event) => {
                changeRatingValue(event);
            });

            rating.addEventListener('mouseover', (event) => {
                let isChecked = (findIn('.js-rate-product__star input', rating).checked === true);
                if(!isChecked){
                    changeRatingValue(event);
                }
            });

            let rateProductStars = findAllIn(Selectors.RateProductStar, rating);
            rateProductStars.forEach((element) => {
                element.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    changeRatingValue(event);

                    ratingInputs.forEach((ratingInput) => {
                        ratingInput.checked = false;
                    });

                    let currentRatingInput = findIn('input', closest('.js-rate-product__star', event.target));
                    if(currentRatingInput) {
                        currentRatingInput.checked = true;
                    }

                });
            });
        }

        function changeRatingValue(event) {

            const productStar = closest('.js-rate-product__star', event.target);
            if(!productStar) {
                return;
            }
            const numberOfStars = productStar.getAttribute('data-stars');
            if(numberOfStars){
                for(let i = 0; i < rateProductStars.length; i++){
                    let currentStarIcon = findIn(Selectors.RateProductStarVisual, rateProductStars[i]);
                    if(i < numberOfStars){
                        currentStarIcon.classList.add('icon-maiersports-star');
                        currentStarIcon.classList.remove('icon-star-empty')
                    }else{
                        currentStarIcon.classList.remove('icon-maiersports-star');
                        currentStarIcon.classList.add('icon-star-empty');
                    }
                }
            }
        }
    });
}
